import { matchMedia } from 'window';
import ko from 'rgs-knockout';
import _ from 'lodash';

import {SIZES} from './settings';

const minWidth = w => isFinite(w) ? `(min-width: ${w}px)` : '';
const maxWidth = w => isFinite(w) ? `(max-width: ${w}px)` : '';
const and = (a, b) => {
	if (!a) {
		return b;
	}
	if (!b) {
		return a;
	}
	return a + ' and ' + b;
};

const screenWidthName = ko.observable(_.last(SIZES).name);

if (matchMedia) {
	_.each(SIZES, ({ name, min, max }) => {
		const query = and(minWidth(min), maxWidth(max));
		const handler = (mql) => {
			if (mql.matches) {
				screenWidthName(name);
			}
		};
		const mq = matchMedia(query);
		mq.addListener(handler);
		handler(mq);
	});
}

const screenObserver = ko.pureComputed(() => screenWidthName());

export const isValueEqualGiven = value => {
	return screenObserver.peek() === value;
};

export default screenObserver;

